// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgHappyPowerLoyaltyIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M14.872 13.5a.5.5 0 0 1 .411.784 4 4 0 0 1-2.978 1.703h-.61a4 4 0 0 1-2.978-1.703.5.5 0 0 1 .821-.568A2.98 2.98 0 0 0 12 15a3 3 0 0 0 2.459-1.284.5.5 0 0 1 .41-.216zM9.5 10a1.5 1.5 0 0 1 1.414 2H8.086A1.498 1.498 0 0 1 9.5 10m5 0a1.5 1.5 0 0 1 1.414 2h-2.828a1.5 1.5 0 0 1 1.414-2" />
    <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm-7 3a6 6 0 1 0 0 12 6 6 0 0 0 0-12" />
  </g>
);
export default SvgHappyPowerLoyaltyIcon;
SvgHappyPowerLoyaltyIcon.displayName = 'SvgHappyPowerLoyaltyIcon';
